import { Button } from '@platform/components';

/** A panel that prompts unauthed users to join MovingWorlds */
export const JoinAlert = () => {
  return (
    <div className='bg-secondary-brand-25 p-6 shadow rounded-2xl flex flex-col sm:flex-row gap-6 sm:gap-0 items-center'>
      <div className='flex flex-col gap-2'>
        <span className='text-2xl sm:text-xl font-semibold'>
          Join MovingWorlds to collaborate for impact
        </span>
        <span className='text-md sm:text-sm text-gray-400'>
          Whether you're a professional offering skills or a social enterprise seeking support, our
          network helps you grow and make a difference.
        </span>
      </div>
      <div className='pl-2 ml-auto flex flex-col sm:flex-row w-full sm:w-fit gap-3 text-nowrap'>
        <Button variant='secondary-gray' size='lg' href='/platform'>
          Learn more
        </Button>
        <Button variant='accent' size='lg' href='/platform/auth/sign-up'>
          Get started
        </Button>
      </div>
    </div>
  );
};
